import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./nav-styles.css";
import { NavHashLink } from "react-router-hash-link";

export default function SideNavAccordian({
  title,
  subtitles,
  activeSideBar,
  activeKey,
  onChangeSideBar,
  url,
  target
}) {
  const [isOpen, setisOpen] = useState(false);

  useEffect(() => {
    if (activeSideBar !== activeKey) {
      setisOpen(false);
    }
  }, [activeSideBar]);

  const onClick = () => {
    setisOpen(!isOpen);
    onChangeSideBar(activeKey);
  };
  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80; 
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
  }
  
  return (
    <li>
      {target ? (
        <a href={url} target={'_blank'}>
          <span className="side-nav-menu-text" onClick={onClick}>
            {title}
          </span>
        </a>
      ) : (
        <Link to={url}>
          <span className="side-nav-menu-text" onClick={onClick}>
            {title}
          </span>
        </Link>
      )}
      <div>
        <ul className="side-nav-submenu-wrapper">
          {isOpen
            ? subtitles.map((subtitle, key) => (
                <li className="side-nav-subment-text" key={key}>
                  <NavHashLink
                    smooth
                    to={subtitle.to}
                    activeClassName="selected"
                    activeStyle={{ color: "orange" }}
                    className="side-nav-subment-text"
                    scroll={el => scrollWithOffset(el)}
                  >
                    - {subtitle.title}
                  </NavHashLink>
                </li>
              ))
            : ""}
        </ul>
      </div>
    </li>
  );
}
